import {
  type BaseError,
  type CodeError,
  type IApiError,
} from '@webapp/services/api'

export const getResponseObject = <T extends object | object[] = object>(
  data: T = null,
  pagination = {},
  metadata = {}
) => ({
  data,
  metadata: {
    pagination: {
      count: Array.isArray(data) ? data.length : null,
      page_size: 10,
      current_page: 1,
      num_pages: 1,
      previous: null,
      next: null,
      ...pagination,
    },
    ...metadata,
  },
})

export const getErrorResponseObject = (
  data: object[] | object = null,
  nonFieldError: BaseError = null,
  fieldErrors: CodeError[] = []
): IApiError['data'] => {
  if (nonFieldError) {
    return {
      data,
      metadata: {},
      errors: {
        non_field_errors: nonFieldError,
      },
      errors_with_codes: [
        {
          field: 'non_field_errors',
          ...nonFieldError,
        },
      ],
    }
  } else if (fieldErrors.length > 0) {
    const errors = {}
    fieldErrors.forEach((fieldError) => {
      const { field, ...fieldErrorObject } = fieldError
      errors[fieldError.field] = fieldErrorObject
    })
    return {
      data,
      metadata: {},
      errors,
      errors_with_codes: fieldErrors,
    }
  } else {
    return {
      data,
      metadata: {},
      errors: {},
      errors_with_codes: [],
    }
  }
}
